<template>
    <with-dimensions>
        <table-ish slot-scope="{ width }">
            <table-ish-row-router-link
                v-for="transaction in transactions"
                :key="transaction.uuid"
                :to="to(transaction)"
            >
                <table-ish-cell>
                    <with-variables :variables="{ transaction }">
                        <truncate-hack slot-scope="{ transaction: { transactionable: { properties: { data: properties } } } }">
                            {{ properties | comma-delimited({
                                callback: (property) => property.name,
                                total: properties.length
                            }) }}
                        </truncate-hack>
                    </with-variables>

                    <with-variables
                        v-if="transaction.object === 'charge'"
                        slot="secondary"
                        :variables="{ transaction }"
                    >
                        <landlords-current slot-scope="{ transaction: { transactionable: { payer } } }">
                            <truncate-hack slot-scope="{ data: landlord }">
                                <template v-if="payer.object === landlord.object && payer.uuid === landlord.uuid">
                                    You
                                </template>
                                <template v-else>
                                    {{ payer.name }}
                                </template>
                            </truncate-hack>
                        </landlords-current>
                    </with-variables>

                    <with-variables
                        v-else-if="transaction.object === 'payment'"
                        slot="secondary"
                        :variables="{ transaction }"
                    >
                        <landlords-current slot-scope="{ transaction: { transactionable: { charge: { payer } } } }">
                            <truncate-hack slot-scope="{ data: landlord }">
                                <template v-if="payer.object === landlord.object && payer.uuid === landlord.uuid">
                                    You
                                </template>
                                <template v-else>
                                    {{ payer.name }}
                                </template>
                            </truncate-hack>
                        </landlords-current>
                    </with-variables>

                    <template
                        v-else-if="transaction.object === 'payout'"
                        slot="secondary"
                    >
                        {{ transaction.transactionable.statement_descriptor }}
                    </template>
                </table-ish-cell>

                <table-ish-cell
                    v-if="width > 500"
                    :shrink="true"
                    class="text-right"
                >
                    <span
                        v-if="transaction.object === 'charge' && transaction.transactionable.is_offline"
                        class="px-3 py-1 text-sm font-semibold rounded-full"
                        :class="
                            transaction.transactionable.state === 'requested'
                                ? 'bg-yellow-lighter text-yellow-darker'
                                : 'bg-grey-lighter text-grey-darker'
                        "
                    >
                        Offline
                        <template v-if="transaction.transactionable.state === 'requested'">
                            (requested)
                        </template>
                    </span>

                    <span
                        v-else-if="transaction.object === 'payment'"
                        class="px-3 py-1 text-sm font-semibold rounded-full bg-blue-lighter text-blue-darker"
                    >
                        Money In
                    </span>

                    <span
                        v-else-if="transaction.object === 'payout'"
                        class="px-3 py-1 text-sm font-semibold rounded-full bg-green-lighter text-green-darker"
                    >
                        Money Out
                    </span>
                </table-ish-cell>

                <table-ish-cell
                    :shrink="true"
                    class="text-right"
                >
                    {{ transaction.transactionable.amount | money }}

                    <template slot="secondary">
                        <template v-if="width < 500">
                            <span
                                v-if="transaction.object === 'charge' && transaction.transactionable.is_offline"
                                class="px-2 text-xs font-semibold leading-none rounded-full"
                                :class="
                                    transaction.transactionable.state === 'requested'
                                        ? 'bg-yellow-lighter text-yellow-darker'
                                        : 'bg-grey-lighter text-grey-darker'
                                "
                            >
                                Offline
                                <template v-if="transaction.transactionable.state === 'requested'">
                                    (requested)
                                </template>
                            </span>

                            <span
                                v-else-if="transaction.object === 'payment'"
                                class="px-2 text-xs font-semibold leading-none rounded-full bg-blue-lighter text-blue-darker"
                            >
                                Money In
                            </span>

                            <span
                                v-else-if="transaction.object === 'payout'"
                                class="px-2 text-xs font-semibold leading-none rounded-full bg-green-lighter text-green-darker"
                            >
                                Money Out
                            </span>
                        </template>

                        <template v-else>
                            {{ transaction.created_at | moment('D MMM YYYY') }}
                        </template>
                    </template>
                </table-ish-cell>
            </table-ish-row-router-link>
        </table-ish>
    </with-dimensions>
</template>

<script>
    import LandlordsCurrent from '../components/landlords-current'
    import StateCssMixin from '../mixins/state-css'

    export default {
        mixins: [
            StateCssMixin
        ],
        components: {
            LandlordsCurrent
        },
        props: {
            transactions: {
                type: Array,
                required: true
            }
        },
        methods: {
            to (transaction) {
                if (transaction.object === 'payment') {
                    return {
                        name: this.$router.fix('dashboard.*.payments.show'),
                        params: {
                            payment: transaction.transactionable.uuid
                        }
                    }
                } else if (transaction.object === 'payout') {
                    return {
                        name: this.$router.fix('dashboard.*.payouts.show'),
                        params: {
                            payout: transaction.transactionable.uuid
                        }
                    }
                }

                return {
                    name: this.$router.fix('dashboard.*.charges.show'),
                    params: {
                        charge: transaction.transactionable.uuid
                    }
                }
            }
        }
    }
</script>
